import * as React from "react";
import cx from "classnames";

import CardItem from "./cardItem";
import ListItem from "./listItem";

const styles = require("./userList.scss");

export enum Type {
  Card,
  List,
}

interface IProps {
  users: ReadonlyArray<Vingle.User.IListUser>;
  onFollowClick: (user: Vingle.User.IListUser) => void;
  type: Type;
  currentUser: Vingle.User.ICurrentUser | null;
  listClassName?: string;
  itemClassName?: string;
  emptyElement?: React.ReactNode;
}

const UserList = ({
  currentUser,
  users,
  onFollowClick,
  type,
  listClassName,
  itemClassName,
  emptyElement,
}: IProps) => {
  let Item: typeof CardItem | typeof ListItem;
  switch (type) {
    case Type.Card: {
      Item = CardItem;
      break;
    }
    case Type.List: {
      Item = ListItem;
      break;
    }
  }

  return users && users.length > 0 ? (
    <div className={cx(styles.userList, listClassName)}>
      {users.map(user => {
        const isOwn = user.id === (currentUser && currentUser.id);
        return (
          <Item
            key={user.id}
            user={user}
            isOwn={isOwn}
            onFollowClick={onFollowClick}
            className={itemClassName}
          />
        );
      })}
    </div>
  ) : emptyElement ? (
    <div>{emptyElement}</div>
  ) : null;
};

export default UserList;
